import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment-timezone'
import {init, sendOrder} from '@/api/api'
import createPersistedState from 'vuex-persistedstate'

const SERVICE_BASE = 'base'
const SERVICE_ACTION = 'action'
const SERVICE_BASE_ID = 4;

Vue.use(Vuex);

const state = {
  sluzba: {
    id: null,
    typ: null,
  },
  services: [],
  serviceTypes: {},
  selectLode: false,
  order: {
    datumKonani: null,
    datumKonaniDo: null,
    konaniOd: null,
    konaniDo: null,
    mistoVyzvednuti: null,
    mistoOdevzdani: null,
    pocetPrken: null,
    pocetVest: null,
    pocetVodnichSvetu: null,
    pocetSlapadel: null,
    pocetKanoi: null,
    pocetKolobezek: null,
    pocetPadel: null,
    doprava: false,
    dopravaKolobezka: false,
    dopravaKolobezkaOd: null,
    pocetDoprav: null,
  },
  prices: {},
  customer: {
    name: '',
    email: '',
    telephone: '',
    city: '',
  },
  payType: 'cash',
  actualStep: 1,
  pobockyOptions: {},
  multiDayRezervation: false,
    fastSelectChose: null,
}

const mutations = {
  setService(state, id) {
    let oldState = state.sluzba.typ;
    state.sluzba.id = id;

    const mainServiceID = state.services.find(item => typeof item.type_of_action !== "undefined" && item.type_of_action === "hlavni_sluzba").nid;

    state.sluzba.typ = id === mainServiceID ? SERVICE_BASE : SERVICE_ACTION;

    if(oldState != state.sluzba.typ && state.sluzba.typ){
      state.multiDayRezervation = false;
    }
  },
  swapMultiDayRezervation(state, val) {
    Vue.set(state, 'multiDayRezervation', val);
  },
  setSelectLode(state, val) {
    state.selectLode = val;
  },
  setActionsList(state, actionList) {
    state.services = state.services.slice(0, 0).concat(actionList);

      state.services.filter(item => item.nid != 4 && item.nid != 281 && item.nid != 1982 && item.node_typ_akce_nid != null && (!state.selectLode || item.cena_doprava_lode != null)).forEach(function (service) {
          state.serviceTypes["node_" + service.node_typ_akce_nid] = {
            'title' : service.title,
            'key' : service.node_typ_akce_nid,
            'key_in_list' : "node_" + service.node_typ_akce_nid,
              'popis': service.popis,
              'url': service.url,
              'misto_zacatku' : service.misto_zacatku,
              'misto_konce' : service.misto_konce,

          };
      })
  },
  setOrder(state, order) {
    Vue.set(state, 'order', order);
  },
  setCustomer(state, customer) {
    Vue.set(state, 'customer', customer);
  },
  setActualStep(state, stepID) {
    Vue.set(state, 'actualStep', stepID);
  },
  setPayType(state, payType) {
    Vue.set(state, 'payType', payType);
  },
  setPocetPrken(state, pocetPrken) {
    Vue.set(state.order, 'pocetPrken', pocetPrken);
  },
  setPobockyOptions(state, pobocky) {
    Vue.set(state, 'pobockyOptions', pobocky);
  },
  resetServices(state) {
    Vue.set(state, 'services', []);
    Vue.set(state, 'serviceTypes', {});
  },
  resetOrder(state) {
    Vue.set(state, 'order', {
      datumKonani: null,
      datumKonaniDo: null,
      konaniOd: null,
      konaniDo: null,
      mistoVyzvednuti: null,
      mistoOdevzdani: null,
      pocetPrken: null,
      pocetVest: null,
      pocetVodnichSvetu: null,
      pocetSlapadel: null,
      pocetKanoi: null,
      pocetKolobeze: null,
      pocetPadel: null,
      doprava: false,
      pocetDoprav: null,
    });
  },
  setDefaultMultiDayRezervation(state) {
    state.multiDayRezervation = false
  },
  setOneHourRezervation(state, dateTime) {
    Vue.set(state, 'order', {
      datumKonani: null,
      datumKonaniDo: null,
      konaniOd: null,
      konaniDo: null,
      mistoVyzvednuti: null,
      mistoOdevzdani: null,
      pocetPrken: null,
      pocetVest: null,
      pocetVodnichSvetu: null,
      pocetSlapadel: null,
      pocetKanoi: null,
      pocetKolobezek: null,
      pocetPadel: null,
      doprava: false,
      pocetDoprav: null,
    });
  },
    setfastSelectChose(state, chose) {
        Vue.set(state, 'fastSelectChose', chose);
    },
}

const actions = {
  setService({commit}, id) {
    commit('setService', id);
    commit('resetOrder');
    commit('setActualStep', 2);
  },
  init({commit}) {
    init().then(response => {
      commit('setActionsList', response.data.data.actions);
      commit('setPobockyOptions', response.data.data.pobocky_options);
    })
  },
  setOrder({commit}, order) {
    commit('setOrder', order);
    commit('setActualStep', 3);
  },
  setCustomer({commit}, customer) {
    commit('setCustomer', customer);
    commit('setActualStep', 4);
  },
  setPayType({commit}, payType) {
    commit('setPayType', payType);
    commit('setActualStep', 5);
  },
  setOneHourRezervation() {

  },
  completeOrder({commit, state}) {

    let from = moment.tz(state.order.datumKonani + ' ' + state.order.konaniOd, 'YYYY-MM-DD H:m', 'Europe/Prague').utc();
    let to = moment.tz(state.order.datumKonaniDo + ' ' + state.order.konaniDo, 'YYYY-MM-DD H:m', 'Europe/Prague').utc();

    let order = Object.assign({}, state.order);

    order.datumKonani = from.format('YYYY-MM-DD');
    order.datumKonaniDo = to.format('YYYY-MM-DD');
    order.konaniOd = from.format('H:mm');
    order.konaniDo = to.format('H:mm');

    if(order.dopravaKolobezka){
      let fromKolobezka = moment.tz(state.order.datumKonani + ' ' + state.order.dopravaKolobezkaOd, 'YYYY-MM-DD H:m', 'Europe/Prague').utc();
      order.dopravaKolobezkaOd = fromKolobezka.format('H:mm');
    }

    return sendOrder({
      sluzba: state.sluzba,
      order: order,
      payType: state.payType,
      customer: state.customer,
    }).then(response => {
      commit('setActualStep', 6);
    });
  }
}

const getters = {
  selectedService(state) {
    return state.services.find(item => item.nid == state.sluzba.id);
  },
  getMainServiceID(state) {
    return state.services.find(item => typeof item.type_of_action !== "undefined" && item.type_of_action === "hlavni_sluzba");
  },
  sluzba(state) {
    return state.sluzba;
  },
  getOrder(state) {
    return state.order;
  },
  getCustomer(state) {
    return state.customer;
  },
  getPayType(state) {
    return state.payType;
  },
  getMultiDayRezervation(state) {
    return state.multiDayRezervation;
  },
  getActualStep(state) {
    return state.actualStep;
  },
  getPobockyOptions(state) {
    return state.pobockyOptions.map(item => {
      return {text: item.text, value: item.text}
    });
  },
  getPobocky(state) {
    return state.pobockyOptions;
  },
  getDatumKonaniOd(state) {
    return state.order.datumKonani;
  },
  getDatumKonaniDo(state) {
    return state.order.datumKonaniDo;
  },
  getPobockyOptionsArray(state) {
    let pobocky = {};
    state.pobockyOptions.forEach(item => pobocky[item.value] = item.text);

    return pobocky;
  },
    getfastSelectChose(state){
      return state.fastSelectChose;
    }
}

const store = new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  plugins: [createPersistedState({storage: window.sessionStorage})]
})

export default store;



// WEBPACK FOOTER //
// ./src/store/store.js